<!-- src/views/ParametresPharmaciePage.vue -->
<template>
    <div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div class="row w-100 justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 bg-white py-5">
          <!-- Message au-dessus du card -->
          <div class="text-center mb-4">
            <h2 class="mb-2">
              Paramétrage de la pharmacie
            </h2>
            <p class="text-muted mb-0">
              Merci de renseigner les informations de votre pharmacie pour pouvoir utiliser l’application.
            </p>
          </div>
  
          <!-- Card centré avec le formulaire -->
          <Card>
            <template #content>
              <!-- Composant existant qui contient le formulaire de paramètres -->
              <InfosPharmacie @saved="onSaved" />
            </template>
          </Card>
        </div>
      </div>
    </div>
</template>
  
<script lang="ts">
  import { defineComponent } from 'vue';
  import Card from 'primevue/card';
  
  import InfosPharmacie from './admin/parametres/InfosPharmacie.vue';
  
  export default defineComponent({
    name: 'ParametresPharmaciePage',
    components: {
      Card,
      InfosPharmacie,
    },
    methods: {
        /**
         * Lorsque l’enregistrement est réussi dans InfosPharmacie.vue
         */
        onSaved() {
        // ⭐ Redirection vers la page d’accueil
        this.$router.push({ name: 'home' });
        },
    },
  });
  </script>
  
  <style scoped>
  /* Optionnel : légère ombre pour le card */
  .p-card {
    box-shadow: 0 0.5rem 1.2rem rgba(0, 0, 0, 0.08);
  }
</style>
  